import React from 'react';
const blockName = 'team-component'
export default function Team({ name, image, isHome, }){
  const isHomeClass = isHome ? 'home': 'away';
  const classNames = `${ blockName } ${ blockName }--${ isHomeClass }`;
  return (
  <div className={ classNames }>
    <div className={ `${ blockName }__image-container` }>
      <img src={ image } alt={ name } className={ `${ blockName }__image` }/>
    </div>
    <p className={ `${ blockName }__name` }>
      { name }
    </p>
  </div>
  );
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/schedule/components/team.js